export const chatHeadingColors = [
    {'name':'2C2C2C'},
    {'name':'707070'},
    {'name':'3C6748'},
    {'name':'107896'},
    {'name':'AD2A1A'},
    {'name':'C01F2D'}
]

export const CALL_TRANSFER_TO_OPTIONS = [
    { id: 1, name: 'Queue' },
    // {id: 2, name: "Person"}
];
export const CHAT_TRANSFER_TO_OPTIONS = [
    { id: 1, name: 'Queue' },
    // {id: 2, name: "Person"}
];
